import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toastService from '../../../../../utils/toastService';
import {useGetLaborCatalogQuery, useCreateLaborCatalogMutation, useUpdateLaborCatalogMutation, useDeleteLaborCatalogMutation } from '../../../../../api';

const useLaborCatalog = (th) => {
    const navigate = useNavigate();
    const [submitted, setSubmitted] = useState(false);
  const [lazyParams, setLazyParams] = useState({ first: 1, rows: 10, page: 1 });
    const [activeFilters, setActiveFilters] = useState({
        carItemCode: '',
         model: '',
         createdDate: '',
          productGroup: null
    });

    const {
        data: laborCatalog,
        isLoading,
        isFetching,
        error,
        refetch
    } = useGetLaborCatalogQuery({
        pageNumber: lazyParams.page,
        pageSize: lazyParams.rows,
        carItemCode: activeFilters.carItemCode || undefined,
        model: activeFilters.model || undefined,
        createdDate: activeFilters.createdDate || undefined,
         productGroup: activeFilters.productGroup || undefined
    });
    
   const [createLaborCatalog, { isLoading: isCreating }] = useCreateLaborCatalogMutation();
    const [updateLaborCatalog, { isLoading: isUpdating }] = useUpdateLaborCatalogMutation();
    const [deleteLaborCatalog, { isLoading: isDeleting }] = useDeleteLaborCatalogMutation();

    const saveWarrantyPeriod = async (data) => {
        try {
            if (data.id) {
                await updateLaborCatalog(data).unwrap();
                toastService.success(th ? th('common.updateSuccess') : 'İşçilik Kataloğu başarıyla güncellendi');
            } else {
                await createLaborCatalog(data).unwrap();
                toastService.success(th ? th('common.createSuccess') : 'İşçilik Kataloğu  başarıyla eklendi');
            }
            refetch();
            return true;
        } catch (error) {
            toastService.error(th ? th('common.error') : 'İşçilik Kataloğu  kaydedilirken bir hata oluştu');
            return false;
        }
    };
    

    const handleDelete = async (data) => {
        try {
            await deleteLaborCatalog(data).unwrap();
            toastService.success(th ? th('laborCatalog.messages.deleteSuccess') : 'İşçilik Kataloğu  başarıyla silindi');
            refetch();
            return true;
        } catch (error) {
            toastService.error(th ? th('common.error') : 'İşçilik Kataloğu  silinemedi');
            return false;
        }
    };

    const handleFilterChange = (updatedFilters) => {

        const apiFilters = {
            carItemCode: updatedFilters.carItemCode || '',
            model: updatedFilters.model || '',
            createdDate: updatedFilters.createdDate || '',
            productGroup: updatedFilters.productGroup || null
        };

        setActiveFilters(apiFilters);

        setLazyParams((prevParams) => ({
            ...prevParams,
            first: 0,
            page: 1
        }));
    };

    const onPage = (event) => {
        setLazyParams((prev) => ({
            ...prev,
            page: event.page + 1,
            first: event.first,
            rows: event.rows
        }));
    };

    const initFilters = () => {
        setActiveFilters({
            carItemCode: '',
            model: '',
            createdDate: '',
            productGroup: null
        });
        setLazyParams((prevParams) => ({
            ...prevParams,
            first: 0,
            page: 1
        }));
    };
    return {
        laborCatalog: laborCatalog || { items: [], totalCount: 0 },
        isLoading,
        isFetching,
        error,
        lazyParams,
        submitted,
         initFilters,
        handleFilterChange,
        setSubmitted,
        saveWarrantyPeriod,
        onPage,
        handleDelete
    };
};

export default useLaborCatalog;